import { VALIDATION_ERROR_MESSAGE, Yup } from "@mavichpe/dynamic-forms";

const LinkCategoryFormConfig = {
    sections: [
        {
            hideBorderBottom: true,
            fields: [
                [
                    {
                        type: "text",
                        name: "title",
                        label: "Nombre de categoría",
                        isHorizontal: true,
                        labelSizing: { sm: 3 },
                        sizing: { sm: 9 },
                        validation: Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
            ],
        },
    ],
};

export default LinkCategoryFormConfig;
